import firebase from 'firebase/app'

export const fetchMessages = async(startDate, endDate) => {
  const newEndDate = new Date(endDate).setHours(23,59,59,999)
  const newStartDate = new Date(startDate).setHours(0,0,0,0);
  try{
    const  querySnapshot = await firebase.firestore()
    .collection('Messages')
    .where('created_at','>=', new Date(newStartDate))
    .where('created_at','<=', new Date(newEndDate))
    .orderBy('created_at','desc')
    .get()
    const messages = querySnapshot.docs.map((doc) => {
      return {...doc.data(), id:doc.id}
    })
   return {data: messages}
  }
  catch(error){
    console.log(error)
   return {isError: true}
  }
}

export const addMessage = async (message) => {
  try {
    const documentRef = await firebase.firestore().collection('Messages').add(message)
    const messageData = await fetchSingleMessage(documentRef.id)
    if(messageData.data){
    
      return {data: {...messageData.data, id:documentRef.id}}
    }else{
      return {isError: true}
    }
  }
  catch(error){
    return {isError: true}
  }
}

export const updateMessage = async (message) => {
  try{
    await firebase.firestore().collection('Messages').doc(message.id).update(message)
    return {data:true}
  }catch(error){
    return {isError: true}
  }
}

export const fetchSingleMessage = async (id) => {
  try{
    const docSnapshot = await firebase.firestore().collection('Messages').doc(id).get()
    return {data: docSnapshot.data()}
  }
  catch(error){
    return {isError: true}
  }
}

export const deleteMessage = async (id) => {
  try {
    await firebase.firestore().collection('Messages').doc(id).delete()  
    return {data:id}
  } 
  catch(error){
    return {isError: true}
  }
}